import { render, staticRenderFns } from "./ChatRichTextEditor.vue?vue&type=template&id=5c356959&scoped=true"
import script from "./ChatRichTextEditor.vue?vue&type=script&lang=js"
export * from "./ChatRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./ChatRichTextEditor.vue?vue&type=style&index=0&id=5c356959&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c356959",
  null
  
)

export default component.exports